export default ({ store, redirect, app }) => {
  // If user is logged
  if (store.getters['auth/isLogged']) {
    return redirect(app.localePath({ name: 'dashboard' }));
  }
};
